import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";
import TableCard from "../../common/TableCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        title: "Card1",
        hideTitle: true,
        items: [
          {
            label: {
              value: ""
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              placeHolder: true,
              intemName: "placeHolder1",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "Unit Shipped",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "unitShippedTag",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "Dollar Value",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "dollarValueTag",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "Units Received",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "unitsReceivedTag",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "Units Out",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "unitsOutTag",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "Deseasonalized Demand",
              size: "calc(100% - 50px)",
              fontSize: "90%",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "infDD"
            },
            size: "17.5%",
            readOnly: true
          },
          {
            label: {
              value: "Current Week To Date",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cwD",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cwSalesUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cwCost",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cwReceiptsUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cwUnitOuts",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              placeHolder: true,
              intemName: "placeHolder2",
              noInput: true
            },
            size: "17.5%",
            readOnly: true
          },
          {
            label: {
              value: "Current Period To Date",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cpD",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cpSalesUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cpCost",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cpReceiptsUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "cpUnitOuts",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "placeHolder3",
              placeHolder: true,
              noInput: true
            },
            size: "17.5%",
            readOnly: true
          },

          {
            label: {
              value: "Current Year To Date",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "yrD",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "yrSalesUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "yrCost",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "yrReceiptsUnits",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "0 ",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "yrUnitOuts",
              noInput: true
            },
            size: "16.5%",
            readOnly: true
          },
          {
            label: {
              value: "",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              placeHolder: true,
              intemName: "placeHolder4",
              noInput: true
            },
            size: "17.5%",
            readOnly: true
          }
        ]
      },
      {
        title: "Card2",
        hideTitle: true,
        titleRow: [
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 1 - 8",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week1_8"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 9 - 16",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week9_16"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 17 - 24",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week17_24"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 25 - 32",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week25_32"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 33 - 40",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week33_40"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 41 - 48",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week41_48"
            },
            size: "14.285%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Week 49 - 56",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "week49_56"
            },
            size: "14.285%"
          }
        ],
        tableBody: [],
        tableSettings: { maxHeight: "160px" }
      }
    ];
  }
  // this.cardsLayout[1].tableBody
  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
    this.generateTableBody();
  }

  generateTableBody = () => {
    for (let i = 1; i < 57; i++) {
      this.cardsLayout[1].tableBody.push({
        label: {
          value: i,
          size: "30%"
        },

        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: `week${i}Sales`
        },
        size: "7.1425%",
        readOnly: true
      });
    }
  };

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];
        var items = "";
        if (c === 1) {
          items = "tableBody";
        } else {
          items = "items";
        }

        card[items].map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);
    return (
      <Fragment>
        <div style={{ width: "100%" }}>
          <InputCard
            jsonObj={this.cardsLayout[0]}
            setCardsInfo={this.getCardsInfo}
          />
        </div>
        <div style={{ width: "100%" }}>
          <TableCard
            jsonObj={this.cardsLayout[1]}
            setCardsInfo={this.getCardsInfo}
          />
        </div>
      </Fragment>
    );
  };
  render() {
    return (
      <Fragment>
        <div
          className="cards-container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
